import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { gallery } from '../../data/content';
export function GalleryStrip() {
  const shots = gallery.slice(0, 5);
  return <section className="mx-auto max-w-shell px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-554" data-mp="13vw9x2isgz53">
      <Reveal className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-555" data-mp="yu6vdcwcy3c9">
        <div className="max-w-xl" data-id="element-556" data-mp="twdosir577bg">
          <span className="flex items-center gap-3" data-id="element-557" data-mp="txgjl1rl5twn">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-558" data-mp="p43tsob67h2b" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-559" data-mp="k5aqtptif8ge">Ons werk</span>
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-chalk sm:text-4xl" data-id="element-560" data-mp="g50bhmjtv5ov">
            Rechtstreeks uit de werkplaats.
          </h2>
        </div>
        <Link to="/work" className="inline-flex items-center gap-1.5 text-sm text-dim transition-colors duration-200 ease-smooth hover:text-ember" data-id="element-561" data-mp="65riox0p7x43">
          Bekijk de volledige galerij
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-562" data-mp="126qifmkdkl9u" />
        </Link>
      </Reveal>

      <div className="mt-10 grid auto-rows-[180px] grid-cols-2 gap-4 lg:auto-rows-[215px] lg:grid-cols-4" data-id="element-563" data-mp="ofd72vwmetpw">
        {shots.map((shot, i) => <Reveal key={shot.src} delay={i * 0.04} className={`group overflow-hidden rounded-2xl border border-edge ${i === 0 ? 'row-span-2' : ''} ${i === 2 ? 'lg:row-span-2' : ''}`} data-id="element-564" data-mp="tb0sr1bw94qn" data-mpi={i}>
            <img src={shot.src} alt={shot.alt} className="h-full w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.05]" data-id="element-565" data-mp="17406axs48ovk" />
          </Reveal>)}
      </div>
    </section>;
}